import { ContentBase } from '../../content.js';
import { Paginated } from '../../common/pagination.js';
import { NearbyPeoplePage, NearbyPeopleQuery, PersonHit, SearchQuery } from '../../search.js';
export const searchRoutes = {
    nearby: {
        method: 'GET',
        path: '/search/nearby',
        query: NearbyPeopleQuery,
        response: NearbyPeoplePage,
    },
    /** FR-SRCH-01: feeds by user name, post title, tags, location. */
    content: {
        method: 'GET',
        path: '/search/content',
        query: SearchQuery,
        response: Paginated(ContentBase),
    },
    /** FR-SRCH-05/06: any user by name/location, filtered by taxonomies. */
    people: {
        method: 'GET',
        path: '/search/people',
        query: SearchQuery,
        response: Paginated(PersonHit),
    },
    /** FR-SRCH-04: own contacts only. */
    contacts: {
        method: 'GET',
        path: '/search/contacts',
        query: SearchQuery,
        response: Paginated(PersonHit),
    },
};
//# sourceMappingURL=routes.js.map